// Refreshes the forløb dropdown in the journal entry form when the user
// picks a different client. The picker partial is fetched from the server
// (so it includes the active forløb of the newly selected client) and
// replaces the container's contents.
//
// Forløb creation is intentionally NOT handled here — new forløb are
// created from the client's forløb page (Klient → Forløb), so the picker
// stays focused on selection.

const wireClientChange = () => {
  const select = document.querySelector(
    "select[name='journal_entry[client_relation_id]']"
  );
  const container = document.querySelector("[data-forloeb-picker-container]");
  if (!select || !container) return;
  if (container.dataset.forloebClientChangeInit === "1") return;
  container.dataset.forloebClientChangeInit = "1";

  const tpl = container.dataset.pickerUrlTemplate;
  const entryId = container.dataset.journalEntryId;

  select.addEventListener("change", async () => {
    const id = select.value;
    if (!id || !tpl) return;
    let url = tpl.replace("__CLIENT_ID__", encodeURIComponent(id));
    if (entryId && entryId.length > 0) {
      url +=
        (url.includes("?") ? "&" : "?") +
        "journal_entry_id=" +
        encodeURIComponent(entryId);
    }
    try {
      const res = await fetch(url, {
        headers: { Accept: "text/html" },
        credentials: "same-origin",
      });
      if (!res.ok) return;
      container.innerHTML = await res.text();
    } catch (_) {
      // Silent — user can save and reload to recover.
    }
  });
};

const forloebPicker = () => {
  wireClientChange();
};

export default forloebPicker;
